import IKEASlider from "../libraries/IKEASlider";

export default function initSliders(){
   
   /** @type {HTMLElement[]} */
   let selection = document.querySelectorAll(`
      .page-part-product-slider .content, 
      .page-part-blogs-slider .content, 
      .page-part-items-slider .content`);

   // Uses the nodelist polyfill
   selection.forEach(element => {
      let sliderElement = element.querySelector(".slider");

      let buttonPrevious = element.querySelector(".button-slider.left");
      let buttonNext = element.querySelector(".button-slider.right");

      let slider = new IKEASlider(sliderElement);

      if(buttonNext) buttonNext.addEventListener("click", _ => slider.next());
      if(buttonPrevious) buttonPrevious.addEventListener("click", _ => slider.previous());
   });
}